import { autoinject, bindable } from 'aurelia-framework';

@autoinject()
export class LabelValue {
  @bindable label: string = '';
  @bindable value = '';
}
